import { useApolloClient } from '@apollo/client/react';
import { Button, Result } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import MainLoader from '@/shared/ui/main-loader';
import { useAppDispatch, useAppSelector } from '@/store';
import { loadSession } from '@/store/session.slice';

/**
 * Загружает сессию сотрудника после входа: профиль, доступы и разделы. Пока её
 * нет, экраны кабинета не показываются — от разделов зависят роуты и навигация.
 */
const SessionProvider: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const status = useAppSelector((state) => state.session.status);

  useEffect(() => {
    if (status === 'idle') void dispatch(loadSession(client));
  }, [status, dispatch, client]);

  if (status === 'error') {
    return (
      <Result
        status="error"
        title={t('session.error.title')}
        subTitle={t('session.error.description')}
        extra={
          <Button
            type="primary"
            onClick={() => void dispatch(loadSession(client))}
          >
            {t('common.retry')}
          </Button>
        }
      />
    );
  }

  if (status !== 'ready') return <MainLoader fullScreen />;

  return <Outlet />;
};

export default SessionProvider;
